export type Pravokotnik = { x: number; y: number; sirina: number; visina: number };

/** Pravokotnik iz dveh točk vlečenja (v katerikoli smeri), omejen na prikazano sliko. */
export function izVlecenja(
  a: { x: number; y: number },
  b: { x: number; y: number },
  meja: { sirina: number; visina: number },
): Pravokotnik {
  const omeji = (v: number, m: number) => Math.max(0, Math.min(v, m));
  const x1 = omeji(Math.min(a.x, b.x), meja.sirina);
  const y1 = omeji(Math.min(a.y, b.y), meja.visina);
  const x2 = omeji(Math.max(a.x, b.x), meja.sirina);
  const y2 = omeji(Math.max(a.y, b.y), meja.visina);
  return { x: x1, y: y1, sirina: x2 - x1, visina: y2 - y1 };
}

/** Izbor na prikazani (pomanjšani) sliki v piksle prave slike za strežnik. */
export function vPikslihSlike(
  izbor: Pravokotnik,
  prikaz: { sirina: number; visina: number },
  naravna: { sirina: number; visina: number },
): Pravokotnik {
  const fx = naravna.sirina / prikaz.sirina;
  const fy = naravna.visina / prikaz.visina;
  return {
    x: Math.round(izbor.x * fx),
    y: Math.round(izbor.y * fy),
    sirina: Math.round(izbor.sirina * fx),
    visina: Math.round(izbor.visina * fy),
  };
}
